import { createSelector } from "reselect";
// TODO: add constants for profile types
// import { COORDINATOR } from "../utils/constants/profileType";
import registrationTypes from "../utils/constants/user/registrationTypes";
import {
  COMPANY,
  LIGHT,
  LIGHT_1GB,
  PRO,
  SMART,
  STARTER,
  UP,
  VIP,
} from "../utils/constants/userPlanConstants";
import { RootState } from "../../typings/mainState";
import { useSelector } from "react-redux";

// TODO: remove "anys" from this file and replace them with the correct types
const userInfoSelector = (state: RootState) => {
  const userInfo = state?.mainState?.userInfo;
  return userInfo;
};

export const useUserInfoState = () =>
  useSelector((rootState: RootState) => rootState.mainState.userInfo);

export const useUserIdState = () => useUserInfoState().id;

export const getUserIdState = createSelector([userInfoSelector], (userInfo) => userInfo.id);

export const getUserNameState = createSelector([userInfoSelector], (userInfo) => userInfo.name);

export const getUserCreatedAt = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.createdAt
);

export const getUserNamespaceState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.namespace
);

export const getUserPlanState = createSelector([userInfoSelector], (userInfo) => userInfo.plan);

export const getUserUpdatedPlanPackageState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.hasUpdatedPlanPackage
);

export const getUserProfileState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.profile
);

export const isCoordinatorState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.profile === "COORDINATOR"
);

export const isCollaboratorState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.profile === "COLLABORATOR"
);

export const getUserIsAdminState = createSelector([userInfoSelector], (userInfo) => userInfo.admin);

export const getUserEmailState = createSelector([userInfoSelector], (userInfo) => userInfo.email);

export const getTenantIdState = createSelector([userInfoSelector], (userInfo) => userInfo.tenantId);

export const getUserInfoState = createSelector([userInfoSelector], (userInfo) => userInfo);

export const getBillingAccessState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.billingAccess
);

export const getUserStatusState = createSelector([userInfoSelector], (userInfo) => userInfo.status);

export const isTrialState = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.status === registrationTypes.TRIAL
);

export const isPro = createSelector(
  [getUserPlanState],
  (plan) => plan === PRO || plan === COMPANY || plan?.includes(VIP)
);

export const isStarter = createSelector(
  [getUserPlanState],
  (plan) => plan === STARTER || plan === UP || plan === SMART
);

export const isUpOrSmart = createSelector(
  [getUserPlanState],
  (plan) => plan === UP || plan === SMART
);

export const isCompany = createSelector([getUserPlanState], (plan) => plan === COMPANY);

export const isSmart = createSelector([getUserPlanState], (plan) => plan === SMART);

export const isUp = createSelector([getUserPlanState], (plan) => plan === UP);

export const isLight = createSelector(
  [getUserPlanState],
  (plan) => plan === LIGHT || plan === LIGHT_1GB
);

export const isSearchObjectsNormalized = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.searchObjectsNormalized
);

export const hasAlreadyTriedLight = createSelector(
  [userInfoSelector],
  (userInfo) => userInfo.alreadyTriedLight
);
